import "./style.css";
import { initAnalytics } from "./analytics";

const CONTACT_EMAIL = "business@fast2d.com";

function initLicenseForm(): void {
	const form = document.getElementById("license-form") as HTMLFormElement | null;
	const status = document.getElementById("cf-status");
	if (!form) return;

	form.addEventListener("submit", (event) => {
		event.preventDefault();
		if (!form.reportValidity()) return;

		const data = new FormData(form);
		const name = String(data.get("name") ?? "").trim();
		const email = String(data.get("email") ?? "").trim();
		const company = String(data.get("company") ?? "").trim();
		const purpose = String(data.get("purpose") ?? "").trim();
		const message = String(data.get("message") ?? "").trim();

		const subject = `Fast2D commercial license — ${purpose || "inquiry"}`;
		const body = [
			`Name: ${name}`,
			`Email: ${email}`,
			company ? `Company: ${company}` : "Company: —",
			`Intended use: ${purpose}`,
			"",
			"Project details:",
			message,
		].join("\n");

		const mailto = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
		window.location.href = mailto;

		if (status) {
			status.textContent = `Opening your email app… if nothing happens, write to ${CONTACT_EMAIL}.`;
		}
	});
}

initAnalytics();
initLicenseForm();
